
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface VehicleType {
  id: string;
  name_ar: string;
  name_en: string;
  sort_order: number;
}

interface VehicleTypesTableProps {
  vehicleTypes: VehicleType[];
  onEdit: (item: VehicleType) => void;
  onDelete: (id: string) => void;
}

export function VehicleTypesTable({ vehicleTypes, onEdit, onDelete }: VehicleTypesTableProps) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>الاسم بالعربية</TableHead>
              <TableHead>الاسم بالإنجليزية</TableHead>
              <TableHead className="text-center">الترتيب</TableHead>
              <TableHead>الإجراءات</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {vehicleTypes.map((type) => (
              <TableRow key={type.id}>
                <TableCell className="font-medium">{type.name_ar}</TableCell>
                <TableCell dir="ltr" className="text-left">{type.name_en}</TableCell>
                <TableCell className="text-center">{type.sort_order}</TableCell>
                <TableCell>
                  <div className="flex gap-2">
                      <Button variant="outline" size="sm" onClick={() => onEdit(type)}>
                          تعديل
                      </Button>
                      <Button variant="destructive" size="sm" onClick={() => onDelete(type.id)}>
                          حذف
                      </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
